import styled from "styled-components"

export const StyledUnlockYourEnglishSection = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
`
